import { Outlet } from "react-router-dom";
import CandidateSidebar from "./CandidateSidebar";
import MobileNav from "./MobileNav";

/**
 * Persistent layout for all candidate pages.
 * The sidebar lives at the route level so it stays mounted across navigations.
 * Page content is rendered inside <Outlet/> on the right.
 */
export default function CandidateLayout() {
  return (
    <div className="flex bg-[#F7F8F6] min-h-screen" data-testid="candidate-layout">
      <CandidateSidebar />
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
      <MobileNav />
    </div>
  );
}
